import React from 'react';
import SettingsLegalDocument from '../SettingsLegalDocument';
import {
  TERMS_AND_CONDITIONS_SECTIONS,
  TERMS_AND_CONDITIONS_TITLE,
} from './termsAndConditionsContent';

const TermsAndConditions = () => (
  <SettingsLegalDocument
    title={TERMS_AND_CONDITIONS_TITLE}
    sections={TERMS_AND_CONDITIONS_SECTIONS}
  />
);

export default TermsAndConditions;
